import { createModel } from "@rematch/core";
import {
  CustomerType,
  DashboardFilterState,
  Score,
  TernaryFilterOption,
} from "src/types";

import { RootModel } from ".";

const initialState: DashboardFilterState = {
  customerType: [CustomerType.PK],
  dateRange: 6,
  electricityFilter: {
    contractExistingFilter: TernaryFilterOption.DISREGARD,
    areaTypeFilter: null,
    supplyTypeFilter: null,
    tariffs: [],
    productFamilies: [],
  },
  gasFilter: {
    contractExistingFilter: TernaryFilterOption.DISREGARD,
    areaTypeFilter: null,
    supplyTypeFilter: null,
    productFamilies: [],
    tariffs: [],
  },
  heatingFilter: {
    contractExistingFilter: TernaryFilterOption.DISREGARD,
    productFamilies: [],
    tariffs: [],
  },
  glassFiberFilter: {
    contractExistingFilter: TernaryFilterOption.DISREGARD,
    productFamilies: [],
    tariffs: [],
  },
  score: Score.CHURN,
  filterGroupsEnabled: {
    electricity: false,
    gas: false,
    heating: false,
    glassFiber: false,
  },
};

export const dashboardFilter = createModel<RootModel>()({
  state: initialState,
  reducers: {
    changeDashboardFilter(state, payload: Partial<DashboardFilterState>) {
      return { ...state, ...payload };
    },
    resetDashboardFilter() {
      return initialState;
    },
  },
});



// WEBPACK FOOTER //
// ./src/models/dashboardFilter.ts